import {Model} from "@bryntum/schedulerpro";
import {getAging} from "../../other/utils/utils";
import {CHECKLIST_ITEM_STATUS_TYPE} from "../../other/constants/OtherKeys.jsx";
import { Checklist } from "./Checklist";
import { HasStableKeyIdentifierMixin } from "./mixins/HasStableKeyIdentifierMixin";

export class ChecklistItems extends HasStableKeyIdentifierMixin(Model) {
  static get $name() {
    return "ChecklistItems";
  }

  declare isPhantom: boolean;
  declare id: number | string;
  declare checklistRecord: Checklist;
  declare description: string;
  declare createdAt: Date;
  declare status: number;
  declare checklistId: number;
  declare archived: boolean;
  declare order: number;
  declare image?: string;
  declare thumbnailUrl?: string;
  declare comment: string;

  static get fields() {
    return [
      { name: "description" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "status" }, // type status [Unchecked => 1, Checked => 2]
      { name: "checklistId", dataSource: "checklist", type: "number" },
      { name: "archived", dataSource: "archived", type: "boolean" },
      { name: "order", type: "number" },
      { name: "aging", persist: false },
      { name: "image", dataSource: "image_url" },
      { name: "thumbnailUrl", dataSource: "thumbnail_url" },
      { name: "comment" },
      { name: "isItemCheck", persist: false }
    ]
  }

  static get relations() {
    return {
      checklistRecord: {
        foreignKey: "checklistId",
        foreignStore: "checklistStore",
        relatedCollectionName: "checklistItems"
      }
    }
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get isItemCheck() {
    return this.get("status") === CHECKLIST_ITEM_STATUS_TYPE.CHECKED;
  }

  set isItemCheck(value) {
    this.set("status", value ? CHECKLIST_ITEM_STATUS_TYPE.CHECKED : CHECKLIST_ITEM_STATUS_TYPE.UNCHECKED)
  }
}

// @ts-expect-error - exposeProperties is internal method
ChecklistItems.exposeProperties();